import { render, staticRenderFns } from "./dspProducts.vue?vue&type=template&id=64ba47e9&scoped=true&"
import script from "./dspProducts.vue?vue&type=script&lang=js&"
export * from "./dspProducts.vue?vue&type=script&lang=js&"
import style0 from "./dspProducts.vue?vue&type=style&index=0&id=64ba47e9&lang=scss&scoped=true&"
import style1 from "./dspProducts.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ba47e9",
  null
  
)

export default component.exports